import { actions, reducer } from './user.slice';
import * as selector from './user.selector';

export default { actions, reducer, selector };
